export const UNNAMED_SECTION = "Untitled section";

export function memberSectionTitle(name) {
  const title = String(name ?? "").trim();
  return title === UNNAMED_SECTION ? "" : title;
}

export function bandSectionTitle(visibleRows) {
  return visibleRows[0]?.sectionTitle ?? "";
}
